import React from 'react';
import classNames from 'classnames';
import cls from './ProgressbarLine.module.css';
import { useProgressbarLine } from './useProgressbarLine';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { EstimatesStatus } from '../../../../types/dashboardInformation';

interface ProgressbarLineProps {
    classes?: string;
    estimateId: number;
    estimateName: string;
    value: number;
    status: EstimatesStatus;
}

export const ProgressbarLine = ({
    classes,
    estimateName,
    estimateId,
    value,
    status,
}: ProgressbarLineProps) => {
    const {} = useProgressbarLine();
    return (
        <div className={classNames(cls.ProgressbarLine, [classes])}>
            <div className={cls.LineName}>
                <Icon
                    iconName={'circle'}
                    fill={status === EstimatesStatus.IN_EXPLOITATIONS ? '#28B57A' : '#01B5DD'}
                />
                <a className={cls.LineLink} href={`/estimate/${estimateId}`}>
                    {estimateName}
                </a>
            </div>
            <div className={cls.container}>
                <div className={cls.Progress}>
                    <div className={cls.BackgroundLine}></div>
                    <div
                        className={cls.ProgressLine}
                        //@ts-ignore
                        style={{ '--progress-width': `${value}%` }}
                    ></div>
                </div>
                <div className={cls.PercentValue}>{value}%</div>
            </div>
        </div>
    );
};
